import {InputAdornment, TextField} from '@mui/material';
import {FC} from 'react';
import {Control, useController} from 'react-hook-form';
import checkIcon from '../../../assets/demo-registration/check.svg';
import phoneIcon from '../../../assets/demo-registration/phone.svg';
import {PhoneMask} from '../../../ui/phone-input/PhoneMask';
import {PHONE_PATTERN} from '../constants';
import {DemoRegistrationFormValues} from '../types';
import styles from '../DemoRegistration.module.scss';

interface Props {
  control: Control<DemoRegistrationFormValues>;
}

export const FormPhoneField: FC<Props> = ({control}) => {
  const {
    field: {value, onChange, onBlur, ref},
    fieldState: {error, isTouched},
  } = useController({
    control,
    name: 'phone',
    rules: {
      required: 'Укажите телефон',
      pattern: {
        value: PHONE_PATTERN,
        message: 'Укажите телефон в формате +7 (XXX) XXX-XX-XX',
      },
    },
  });

  const showSuccess = value.trim().length > 0 && isTouched && !error;

  return (
    <div className={styles.fieldGroup}>
      <label htmlFor="phone" className={styles.fieldLabel}>
        Телефон
        <span className={styles.requiredMark}>*</span>
      </label>
      <TextField
        id="phone"
        inputRef={ref}
        className={styles.textField}
        size="small"
        fullWidth
        value={value}
        placeholder="+7 (8202) 20-20-27"
        onBlur={onBlur}
        onChange={onChange}
        error={!!error}
        helperText={error?.message || ' '}
        InputProps={{
          inputComponent: PhoneMask as never,
          startAdornment: (
            <InputAdornment position="start">
              <span className={styles.leadingIconWrap}>
                <img src={phoneIcon} alt="" className={styles.leadingIcon} />
              </span>
            </InputAdornment>
          ),
          endAdornment: showSuccess ? (
            <InputAdornment position="end">
              <img src={checkIcon} alt="" className={styles.validationIcon} />
            </InputAdornment>
          ) : undefined,
        }}
      />
    </div>
  );
};
